import { IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import React, { Ref } from 'react';
import styles from './searchbar.module.css';

type Props = {
  value: string;
  onChangeValue: (value: string) => void;
  inputRef?: Ref<HTMLInputElement>;
};

export default function SearchBar({ value, onChangeValue, inputRef }: Props) {
  return (
    <div className={styles.container}>
      <div className={styles.logosearch}>
        <div className={styles.iconSearch}></div>
      </div>
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={(e) => onChangeValue(e.target.value)}
        placeholder="Buscar no cardápio"
      />
      {value.length > 0 && (
        <IconButton onClick={() => onChangeValue('')} style={{ marginRight: 10 }}>
          <Close />
        </IconButton>
      )}
    </div>
  );
}
